import type { TourDefinition } from '@renderer/hooks/useTour';

/**
 * Sprint 48 — Tour del Cierre del Día (página de inventario).
 * Diferente a tourCerrarDia (que es el wizard completo). Esta página
 * maneja el snapshot final de insumos vs ventas.
 */
export const tourCierreDelDia: TourDefinition = {
  id: 'cierre_del_dia',
  title: 'Cómo hacer el cierre de inventario',
  steps: [
    {
      element: '[data-tour="cierre-paso-ventas"]',
      popover: {
        title: '1. Resumen de lo que pasó hoy',
        description:
          'Tres cifras de referencia: total de ventas del día, pedidos cobrados e ítems vendidos. Sirven para contrastar con lo que el inventario muestra que se consumió.',
        side: 'bottom',
      },
    },
    {
      element: '[data-tour="cierre-semaforo"]',
      popover: {
        title: '2. Semáforo de insumos',
        description:
          '🟢 Cuadra = físico = teórico (perfecto). 🟡 Diferencia = variación menor al 15% (normal por merma). 🔴 Discrepancia = variación mayor al 15% (requiere atención). ⚪ Sin capturar = aún no contaste ese insumo. ⚫ Agotado = se llegó a cero.',
        side: 'top',
      },
    },
    {
      element: '[data-tour="cierre-semaforo"]',
      popover: {
        title: '3. Capturar conteo físico',
        description:
          'Toca cualquier tarjeta de insumo para abrir el capturador. Ingresa cuántas unidades contaste físicamente. El sistema calcula la diferencia contra el teórico y la registra como AJUSTE. Es opcional pero muy recomendado para control de costos.',
        side: 'top',
      },
    },
    {
      element: '[data-tour="cierre-opciones"]',
      popover: {
        title: '4. Reset de stock (cuidado)',
        description:
          '"Reset al cerrar" lleva todos los insumos a CERO al finalizar. Úsalo si al final del día desechas o reservas todo lo perecedero (carnes, salsas frescas). Si NO marcas esto, el stock teórico se conserva para el día siguiente.',
        side: 'top',
      },
    },
    {
      element: '[data-tour="cierre-boton-cerrar"]',
      popover: {
        title: '5. Cerrar y generar PDF',
        description:
          'Presiona el botón rojo para registrar el cierre oficial. Se genera un PDF con el snapshot completo: ventas, insumos consumidos, ajustes y diferencias. Este registro queda en el historial de cierres para consultas futuras.',
        side: 'top',
      },
    },
  ],
};
